import { render, staticRenderFns } from "./Praxisstellen.vue?vue&type=template&id=23efe1c0&scoped=true"
import script from "./Praxisstellen.vue?vue&type=script&lang=js"
export * from "./Praxisstellen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efe1c0",
  null
  
)

export default component.exports